export default __webpack_public_path__ + "static/media/754.adc236e6.png";